import { useQueries } from "@tanstack/react-query";
import { mvpApiGetProduct, ProductSchema } from "@labeling-tools/api/atlas";

export function useAtlasProducts(productIds: (string | null)[]) {
  const queries = useQueries({
    queries: productIds.map((productId) => ({
      queryKey: ["fetch-atlas-product", productId],
      queryFn: async () => {
        const response = await mvpApiGetProduct({
          path: {
            product_id: productId || "",
          },
        });

        if (response.error) {
          throw new Error(`Failed to fetch product: ${response.error}`);
        }

        return response.data as ProductSchema;
      },
      enabled: !!productId,
    })),
  });

  return {
    products: queries.map((q) => q.data),
    isLoading: queries.some((q) => q.isLoading),
    isError: queries.some((q) => q.isError),
    errors: queries.map((q) => q.error),
  };
}
